var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPath23145(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23145",
    "data-name": "Path 23145",
    d: "M161.25,94.081v27.5a3.751,3.751,0,0,1-3.75,3.75H130a3.751,3.751,0,0,1-3.75-3.75v-27.5a3.751,3.751,0,0,1,3.75-3.75h27.5a3.751,3.751,0,0,1,3.75,3.75m-2.5,0a1.252,1.252,0,0,0-1.25-1.25H130a1.252,1.252,0,0,0-1.25,1.25v27.5a1.252,1.252,0,0,0,1.25,1.25h27.5a1.252,1.252,0,0,0,1.25-1.25ZM137.5,105.956v11.25a.624.624,0,0,1-.625.625h-1.25a.624.624,0,0,1-.625-.625v-11.25a.625.625,0,0,1,.625-.625h1.25a.625.625,0,0,1,.625.625m7.5-7.5v18.75a.624.624,0,0,1-.625.625h-1.25a.624.624,0,0,1-.625-.625V98.456a.625.625,0,0,1,.625-.625h1.25a.625.625,0,0,1,.625.625m7.5,12.5v6.25a.624.624,0,0,1-.625.625h-1.25a.624.624,0,0,1-.625-.625v-6.25a.625.625,0,0,1,.625-.625h1.25a.625.625,0,0,1,.625.625",
    transform: "translate(-126.25 -90.331)",
    fill: "#1a1a1a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath23145);
export default __webpack_public_path__ + "static/media/Path 23145.be31a548b8426f768c889b360a2b3b06.svg";
export { ForwardRef as ReactComponent };